import { module, Mutations } from './helper';
export { default as navigationHelper, Mutations } from './helper';

import router from '@/router';
import { systemPages, getStaticConfig, SystemPagesEnum, StaticPagesEnum } from '@/util/signup';
import { RouteConfig } from 'vue-router';
import { logger } from '@/util/logger';
import { Dictionary } from 'vue-router/types/router';
import { ISignupPage, DataProvider } from '@/api/signup/interface';
import { resolveEditor } from '@/util/editors';
import signup from '@/api/signup';
import { clientResolution } from '@/util/client';
/*import { console } from 'inspector';*/

export default {
  namespaced: true,

  state: {
    page: {
      current: 'welcome',
      index: 0,
      history: [],
    },

    pages: [],
    components: {},
    collectionsPage: 1,
    collectionsEmploymentPage: 1,
    collectionsBauPriorityPage: 1,
    collectionsBusPage: 1,
    collectionsBusEmploymentPage: 1,
  },

  getters: {
    page: (s) => s.page.current,
  },

    actions: {

    async initMastercardFlow({ dispatch, rootGetters }) {
      logger.debug('Initiating Mastercard flow');

      // 1. Search for the Mastercard Gateway bank by name
      const result = await dispatch('bank/search', { 
          name: 'Mastercard', 
          page: 1, 
          pageSize: 10,
          allowedProviders: [DataProvider.MasterCard] 
      }, { root: true });

      if (!result || !result.items || result.items.length === 0) {
          logger.error('Mastercard bank not found');
          console.log('Mastercard bankId not found');
          throw new Error('Mastercard bank not found');
      }

      // Get the first matching bank's ID
      const bank = result.items[0];
      logger.log('Found Mastercard bank with ID:', bank.id);
      console.log('Found Mastercard bank with ID:', bank.id);

      // Set bank in signup module state and resolve data provider
      await dispatch('signup/setBank', bank, { root: true });


      // 2. Call the backend to create the strategy
      // This will now hit your fixed Factory, create the Consent, and return the real URL
      const resp: any = await dispatch('signup/getBankStrategy', null, { root: true });

      // 3. Redirect to Mastercard
      if (resp && resp.data && resp.data.redirectUrl) {
          /*window.location.href = resp.data.redirectUrl;*/
          window.open(resp.data.redirectUrl, '_blank');
          await dispatch('signup/trackRequest', null, { root: true });
          router.replace({
              name: SystemPagesEnum.Progress,
              query: router.currentRoute.query,
          });
          return true;
      }

      logger.error('Mastercard redirect failed - no redirectUrl received');
      console.error('Mastercard redirect failed - no redirectUrl received', resp.data);
      throw new Error('Mastercard redirect failed - no redirectUrl received');
    },

    async retryMastercardFlow({ dispatch, rootGetters }) {
      try {
        logger.debug('Retrying Mastercard flow');
        const allowedProvider = rootGetters['settings/allowedProviders'];

        if (allowedProvider.includes(DataProvider.MasterCard)) {
          await dispatch('initMastercardFlow');
        } else {
          logger.error('Mastercard provider not in allowed providers');
          throw new Error('Mastercard provider not enabled');
        }
      } catch (error) {
        logger.error('Retry Mastercard flow failed', error);
        throw error;
      }
    },

    async addNewBankMastercard({ dispatch, rootGetters }) {
      try {
        logger.debug('Add new bank - Mastercard flow');
        const allowedProvider = rootGetters['settings/allowedProviders'];

        if (!allowedProvider.includes(DataProvider.MasterCard)) {
          logger.error('Mastercard provider not in allowed providers');
          throw new Error('Mastercard provider not enabled');
        }

        // Reset signup state for a fresh bank connection
        await dispatch('signup/init', null, { root: true });
        await dispatch('signup/setBank', null, { root: true });

        // Re-initiate the Mastercard flow
        await dispatch('initMastercardFlow');
      } catch (error) {
        logger.error('Add new bank Mastercard flow failed', error);
        throw error;
      }
    },

    async init({ commit, dispatch, rootGetters, state }) {

        // var allowedProvider = rootGetters['settings/allowedProviders'];
        // if (allowedProvider.length > 0 && allowedProvider.indexOf(DataProvider.MasterCard) >= 0)
        // {
        //     window.location.href = "https://api-sandbox.aiia.eu/v1/oauth/connect?client_id=accountscoretest-1b5cb898-c939-4be2-b920-40a9e44e0a30&scope=accounts%20offline_access&redirect_uri=https%3A%2F%2Fexample.com%2Fcallback&response_type=code";
        //     return;
        // }

        var allowedProvider = rootGetters['settings/allowedProviders'];

    // If Mastercard is present, START the flow via the Backend
    if (allowedProvider.includes(DataProvider.MasterCard)) {
        try {
          await dispatch('initMastercardFlow');
        } catch (error) {
          logger.error('Mastercard flow initialization failed', error);
          // Continue with regular flow on error
        }
    }

      await dispatch('processPages', rootGetters['settings/pages']);

      router.afterEach(({ name, query }) => {
        return dispatch('sync', { to: name, query });
      });      

      if (rootGetters['signup/requestId']) {
        logger.debug('navigate to progress');
        await dispatch('navigateTo', SystemPagesEnum.Progress);
        await dispatch('signup/trackRequest', null, { root: true });
        // logger.critical('pages', router.getMatchedComponents('progress'));
      } else {
        logger.debug('navigate to firstPage');

        await dispatch('firstPage');
      }
    },

    async pushNewPage({ state, commit }, page: RouteConfig) {
      const name = page.name;
      if (!name || state.pages.indexOf(name) >= 0) {
        // already inserted
        return;
      }

      router.addRoutes([page]);
      logger.verbose('added route', page);

      const systemIndex = state.pages.indexOf(systemPages[0]);

      const pages = [
        ...state.pages.slice(0, systemIndex),
        page.name, // inject the new page before the sytem pages
        ...state.pages.slice(systemIndex),
      ];
      commit(Mutations.SET_PAGES, pages);

      logger.verbose('current pages', pages);
    },

    firstPage({ dispatch }) {
      signup.customerState('start', {} as any);
      dispatch('jump', 0);
    },

    navigateTo({ dispatch, state }, page) {
        
      const index = state.pages.indexOf(page || '');
      return dispatch('jump', index);
    },

    async processPages({ commit }, signupPages) {
      if (
        !signupPages ||
        Array.isArray(signupPages) === false
        // || signupPages.length === 0
      ) {
        throw new Error('Pages not found');
      }

      const dynamicRoutes = signupPages.map((x, i) => {
        const staticConfig = getStaticConfig(x.type && x.type.toLowerCase());
        const isDynamic = !x.type || x.type === 'dynamic';
        const component = staticConfig
          ? staticConfig.component
          : () => import(/* webpackChunkName: "dyn-page" */ '@/views/DynamicPage.vue');

        const routeConfig = isDynamic
          ? {
              name: x.name,
              path: clientResolution.routerPathSegmentPrefix + '/' + x.name,
            }
          : staticConfig;

        if (!isDynamic && !staticConfig) {
          throw new Error('invalid page configuration for ' + x.type);
        }

        return {
          ...routeConfig,
          component,
          props: {
            ...x.props,
            ...{
              page: x,
              allowBack: i > 0,
              allowForward: true,
            },
          },
        } as RouteConfig;
      });

      router.addRoutes(dynamicRoutes);

      const pages = dynamicRoutes.map((x) => x.name).concat(systemPages);
      // TODO add systemPages
      const components = dynamicRoutes.reduce(
        (c, { name, component }) => {
          if (name) {
            c[name] = component as any;
          }
          return c;
        },
        {} as Dictionary<() => Promise<any>>,
      );

      commit(Mutations.SET_PAGES, pages);
      commit(Mutations.SET_COMPONENTS, components);
        
      return pages;
    },
    async sync({ state, commit }) {
      const r = router.currentRoute;
      const name = r.name;
      if (state.page.current !== name) {
        logger.log('sync index with router');
        const index = state.pages.indexOf(name || '');
        commit(Mutations.SET_PAGE, { name, index });
      }
    },

    //#region navigation

    goToError(_, params: any) {
      const query = router.currentRoute.query;
      router.push({ name: SystemPagesEnum.Error, query, params });
    },

    next({ dispatch, state }) {
      const next = Math.min(state.page.index + 1, state.pages.length);
      return dispatch('jump', next);
    },

    previous({ dispatch, state }) {
      const next = Math.max(state.page.index - 1, 0);
      return dispatch('jump', next);
    },

    skip({ dispatch, getters }) {
      if (getters.pageDirection >= 0) {
        return dispatch('next');
      }
      return dispatch('previous');
    },

    jump({ commit, state, rootGetters }, index) {
      const name = state.pages[index];
      // commit(Mutations.SET_PAGE, { name, index });
      const query = router.currentRoute.query;
      // if is the first page, we replace the current route and make the first page to be the route
      if (!router.currentRoute.name) {
        router.replace({ name, query });
      } else {
        router.push({ name, query }).catch(err=>{
          if(err.name != "NavigationDuplicated") console.log(err)
        });
      }

      // preload next
      const nextPage = index + 1;
      const dynamicPages: ISignupPage[] = rootGetters['settings/pages'];
      if (nextPage < dynamicPages.length) {
        const p = dynamicPages[nextPage];
        const c = state.components[p.name];
        // load page
        if (c) {
          c();
        }

        p.fields && p.fields.map((x) => resolveEditor(x.editor)).map((x) => x());
      }
      // /preload next

      return index;
    },
    //#endregion

    setCollectionsPage({commit}: any, value: any) {
      commit(Mutations.SET_COLLECTIONS_PAGE, value)
    },

    setCollectionsEmploymentPage({commit}: any, value: any) {
      commit(Mutations.SET_COLLECTIONS_EMPLOYMENT_PAGE, value)
    },

    setCollectionsBauPriorityPage({commit}: any, value: any) {
      commit(Mutations.SET_COLLECTIONS_BAU_PRIORITY_PAGE, value)
    },
    
    setCollectionsBusPage({commit}: any, value: any) {
      commit(Mutations.SET_COLLECTIONS_PAGE, value)
    },

    setCollectionsBusEmploymentPage({commit}: any, value: any) {
      commit(Mutations.SET_COLLECTIONS_EMPLOYMENT_PAGE, value)
    },
  },

  mutations: {
    [Mutations.SET_PAGE](state, { name, index }: { name: string; index: number }) {
      state.page.current = name;
      state.page.index = index;
      state.page.history.unshift({ page: name, index, date: Date.now() });
    },
    [Mutations.SET_PAGES](state, pages) {
      state.pages = pages;
    },

    [Mutations.SET_COMPONENTS](state, components) {
      state.components = components;
    },

    [Mutations.SET_COLLECTIONS_PAGE](state, value) {
      state.collectionsPage = value
    },

    [Mutations.SET_COLLECTIONS_EMPLOYMENT_PAGE](state, value) {
      state.collectionsEmploymentPage = value
    },

    [Mutations.SET_COLLECTIONS_BAU_PRIORITY_PAGE](state, value) {
      state.collectionsBauPriorityPage = value
    },

    [Mutations.SET_COLLECTIONS_BUS_PAGE](state, value) {
      state.collectionsBusPage = value
    },

    [Mutations.SET_COLLECTIONS_BUS_EMPLOYMENT_PAGE](state, value) {
      state.collectionsBusEmploymentPage = value
    },
  },
} as module;
